import { render, staticRenderFns } from "./MyRegister.vue?vue&type=template&id=aa2f51ee&scoped=true"
import script from "./MyRegister.vue?vue&type=script&lang=js"
export * from "./MyRegister.vue?vue&type=script&lang=js"
import style0 from "./MyRegister.vue?vue&type=style&index=0&id=aa2f51ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2f51ee",
  null
  
)

export default component.exports